module.exports = __webpack_public_path__ + "static/media/react-logo.9361df0c.png";